import MediaCard from './common/MediaCard'
import Button from 'components/forms/Button'
import useShoppingBag from 'common/useShoppingBag'
import { ButtonType } from '../../../types/global'
import { useRouter } from 'next/router'
import { getPlanPrice } from 'common/utils/planPrice'
import { PlanSlug } from 'common/planSlugs'
import { FC } from 'react'
import { TPlanSummary } from 'common/cms-types'
import { Tenant, tenantToSlug } from 'common/tenant'

type VirtualAddressPromoCardType = {
  planSummary: TPlanSummary
  tenant?: Tenant
}

const VirtualAddressPromoCard: FC<VirtualAddressPromoCardType> = ({
  planSummary,
  tenant = Tenant.UK,
}) => {
  const au = tenant === Tenant.AU
  const planPrice = getPlanPrice(tenantToSlug(tenant))
  // UK copy says "at Companies House"; AU says "with ASIC"
  const registrar = au ? 'with ASIC' : 'at Companies House'
  const { addPlan } = useShoppingBag()
  const router = useRouter()
  const onBuyClick = () => {
    addPlan(
      planSummary.slug,
      'year',
      planSummary,
      ButtonType.VIRTUAL_ADDRESS_PROMO_CARD,
    )
    router.push(au ? '/au/checkout' : '/checkout')
  }
  return (
    <MediaCard
      image={{
        alt: 'Robot arm with mail',
        desktop: {
          dimensions: {
            height: 741,
            width: 522,
          },
          src: '/images/new/robot-upperhalf-right.png',
        },
        mobile: {
          dimensions: {
            height: 897,
            width: 550,
          },
          src: '/images/new/robot-arm-mail.png',
        },
      }}
      imageContainerWidth={{ desktop: '35%' }}
      imageFitPreset='cover-right'
      layout={{
        desktop: 'content-right-media-left',
        mobile: 'media-top-content-bottom',
      }}
    >
      <div className='d-flex flex-1 flex-column gap-4 px-4 pt-4 pb-5 pe-lg-8 pt-lg-17 pb-lg-7 mt-lg-0 mt-n17'>
        <h2 className='fw-semibold lh-105 fs-fluid-36-52'>
          Set up your company's virtual address in{' '}
          <span className='color-pink2'>less than 10 minutes</span>.
        </h2>
        <span className=' fw-semibold lh-119 fs-18'>
          <h3 className='fw-semibold fs-fluid-18-28'>
            Get a prestigious business address and unlock AI-powered mail
            handling from as little as{' '}
            <strong>
              {planPrice.monthlyOnYearlyPlan(PlanSlug.SCAN_LITE)}
              /month
            </strong>
            .
            <span className='pt-2 d-block'>
              Use the address {registrar} to keep your residential address
              private.
            </span>
          </h3>
          <br />
          <br />
          <span className='lh-132'>
            We receive,{' '}
            <span>
              <strong>securely process, and digitise your mail</strong> with{' '}
              <strong>HaiRo™</strong>, sending it to you within 1 business day.
              {!au &&
                ` Using the registered office address ${registrar} helps keep your personal address private.`}
            </span>
            <br />
            <br />
            <span className='fw-bold'>Physical mail is stored for 30 </span>
            days before secure shredding.
            {!au && (
              <>
                <br />
                <br />
                <span className='fw-bold'>Need a copy?</span> We forward mail
                anywhere in the UK for the cost of a{' '}
                <strong>1st class stamp + 50p</strong>.
                <br />
                <br />
                Add a <strong>WhatsApp for Business number</strong> for{' '}
                {planPrice.monthlyOnYearlyPlan(PlanSlug.PHONE)}
                /month.
              </>
            )}
          </span>
          {!au && (
            <>
              <br />
              {/*Always fs 16*/}
              <span className='fs-16 color-grey5'>
                Only available as an add on, virtual office subscription
                required.
              </span>
            </>
          )}
        </span>
        <Button onClick={onBuyClick} className='align-self-lg-end px-22'>
          Buy Now
        </Button>
      </div>
    </MediaCard>
  )
}

export default VirtualAddressPromoCard
